import { AssistantId } from "@genai/assistant";
import { httpClient, postProcessUpsert } from "@genai/http-client";
import { ChatId, MessageId, ApiSource } from "../model";
import { toSource } from "./toSource";

export const fetchSources = (
  assistantId: AssistantId,
  chatId: ChatId,
  messageId: MessageId,
) => httpClient(
    `/assistants/${assistantId}/chats/${chatId}/messages/${messageId}/source-nodes`,
    {
      method: "GET",
    },
  )
    .then(postProcessUpsert<ApiSource[]>)
    .then((apiChatMessages) => apiChatMessages.map(toSource));
